import photo from './images/btc-bot.png';

function heroSmallScreen() {

    return (
  
      <div className='hero-container'>
        <img className="image-show" src={photo} alt="hero" />     
      </div>
  
      );
  };
  
  export default heroSmallScreen;
